<template>
  <div class="manage-buildings-v2 page-wrapper">
    <h1 class="page-h1">Manage Buildings</h1>

    <!-- Navigation Tabs with CTA Button -->
    <div class="nav-container">
      <div class="nav text-left">
        <router-link
          class="nav-link"
          :to="'/app/buildings/'"
          exact
        >
          Overview
        </router-link>
        <router-link
          class="nav-link"
          :to="'/app/buildings/my-buildings'"
        >
          My Buildings
        </router-link>
        <router-link
          class="nav-link"
          :to="'/app/buildings/all-buildings'"
          v-if="
            userStore.user.type === 'ADMIN' ||
            userStore.user.type === 'SALES' ||
            userStore.user.type === 'MANAGER'
          "
        >
          All Buildings
        </router-link>
      </div>
      
      <!-- CTA Button positioned absolutely -->
      <div class="cta-button">
        <router-link to="/app/pricer">
          <b-button variant="primary">
            <i class="fa fa-plus"></i> New Building
          </b-button>
        </router-link>
      </div>
    </div>

    <!-- Tab Content -->
    <div class="tab-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import { userStore } from '@/stores/userStore'

export default {
  name: 'ManageBuildingsV2Page',
  inject: {
    userStore
  }
}
</script>

<style lang="scss" scoped>
.manage-buildings-v2 {
  .nav-container {
    position: relative;
    margin-bottom: 2rem;
    border-bottom: 1px solid #e9ecef;
  }

  .nav {
    padding-bottom: 0;

    .nav-link {
      font-weight: bold;
      color: #2c3e50;
      padding: 1rem 1.5rem;
      text-decoration: none;
      border-bottom: 3px solid transparent;
      transition: all 0.3s ease;
      display: inline-block;
      margin: 0 0.5rem;

      &:hover {
        color: #007bff;
        border-bottom-color: #007bff;
      }

      &.router-link-active {
        color: #007bff;
        border-bottom-color: #007bff;
      }

      &::after {
        content: '';
        margin: 0;
      }
    }
  }

  .cta-button {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
  }

  .tab-content {
    min-height: 500px;
  }
}
</style>
